import { useState } from 'react';
import BacktestControlPanel from '../components/BacktestControlPanel';
import BacktestContractChart from '../components/BacktestContractChart';
import BacktestTable from '../components/BacktestTable';

// Interactive backtest for the cheap-bot ignition trigger (backend:
// handlers/cheap_backtest_run.go + cmd/cheapbacktest, both built on
// backend/backtest). Control panel (date-range picker, on-demand data cache
// via "Load Data", live-editable strategy params, stoppable "Start"/"Stop"
// run) above the results table. Admin-only.
//
// SPY panel/table DISABLED 2026-07-11 (SPX-only focus per user). The
// backend still supports variant=spy and the cached SPY data is untouched -
// restore the commented block below to bring it back.
export default function BotTest() {
  const [spxRefresh, setSpxRefresh] = useState(0);
  // Chart of whichever row was last clicked in the SPX results table,
  // reading straight from the cached bars (see BacktestContractChart).
  const [selectedSpxContract, setSelectedSpxContract] = useState(null);

  return (
    <div>
      {/*
      <BacktestControlPanel variant="spy" onResultsUpdated={() => setSpyRefresh((n) => n + 1)} />
      <BacktestTable
        variant="spy"
        title="Backtest (SPY)"
        subtitle="Pick a test period above, Load Data to cache it (only fetched from Alpaca once), then Start to run the ignition trigger against it with the parameters shown. Bars carry no bid/ask, so entries are simulated at last-trade (slightly optimistic vs paying the ask)."
        refreshSignal={spyRefresh}
      />
      */}
      <BacktestControlPanel variant="spx" onResultsUpdated={() => setSpxRefresh((n) => n + 1)} />
      <BacktestContractChart variant="spx" contract={selectedSpxContract} />
      <BacktestTable
        variant="spx"
        title="Backtest (SPX)"
        subtitle="Pick a test period above, Load Data to cache it (only fetched from Alpaca once), then Start to run the ignition trigger against it with the parameters shown. Bars carry no bid/ask, so entries are simulated at last-trade (slightly optimistic vs paying the ask). Click a row to chart that contract."
        refreshSignal={spxRefresh}
        onSelect={setSelectedSpxContract}
      />
    </div>
  );
}
